import React from 'react';

const CompanyStatusToggle = ({ theme, permissions, styles, onToggle }) => {
  return (
    <div style={{
      background: theme === "light" ? "rgba(46,124,186,0.05)" : "rgba(46,124,186,0.1)",
      border: theme === "light" ? "1px solid #2e7cba" : "1px solid rgba(46,124,186,0.3)",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "24px",
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div>
          <h4 style={{
            fontSize: "16px",
            fontWeight: "600",
            color: theme === "light" ? "#0f172a" : "#ffffff",
            marginBottom: "4px",
          }}>
            Company Status
          </h4>
          <p style={{
            fontSize: "13px",
            color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.7)",
          }}>
            {permissions.isActive
              ? "Company is currently active"
              : "Company is currently inactive"}
          </p>
        </div>
        <div style={styles.toggle(permissions.isActive)} onClick={() => onToggle('isActive')}>
          <div style={styles.toggleKnob(permissions.isActive)} />
        </div>
      </div>
    </div>
  );
};

export default CompanyStatusToggle;